<template>
  <div id="view-not-found">
    <ContentHeader>
      <h1 class="header__title">{{ content.title }}</h1>
      <p class="header__text">{{ content.text }}</p>
      <RouterLink
        :style="{ marginTop: '1.5rem', textDecoration: 'underline', fontWeight: 600 }"
        :to="{ name: 'home' }"
        >{{ content.label }}</RouterLink
      >
    </ContentHeader>
  </div>
</template>

<script>
import { ContentHeader } from '@/components/content'

export default {
  name: 'NotFound',
  components: { ContentHeader },
  data() {
    return {
      strings: {
        fr: {
          title: 'Page introuvable',
          text: 'La page que vous semblez chercher n’existe malheureusement pas. Explorez plutôt nos autres pages !',
          label: `Retourner à l'accueil`
        },
        en: {
          title: 'Page not found',
          text: `The page you seem to be looking for isn't here. Take a look around to see if you don't find what you need!`,
          label: 'Back to the homepage'
        }
      }
    }
  },
  computed: {
    content() {
      return this.strings[this.$lang.current]
    }
  },
  beforeMount() {
    if (this.$route.name === 'catch-all') this.$router.replace({ name: 'not-found' })
  }
}
</script>
